<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <div class="form-container">
      <LocomotiveFieldFactory
        v-model="locomotive"
        label="Numery lokomotyw"
        :companyId="this.serviceCompany.id"
        :icon="null"
        :rules="[required]"
      />
    </div>
    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import LocomotiveFieldFactory from '@/component/Field/Locomotive/locomotive-field-factory';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';

export default {
  name: 'LocomotiveControlReview',
  components: {
    LocomotiveFieldFactory,
    DialogSaveButton,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    entity: Object,
    company: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      locomotive: null,
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      [this.locomotive] = this.entity.locomotives;
    } else if (this.isLocomotiveControlReviewAdded) {
      const service = this.$store.getters['service/services'].find(({ serviceType }) => serviceType === this.type);
      [this.locomotive] = service.locomotives;
    }
  },
  computed: {
    isLocomotiveControlReviewAdded() {
      return this.$store.getters['service/services'].find(({ serviceType }) => serviceType === this.type);
    },
    serviceCompany() {
      return this.company || this.$store.getters['service/serviceCompany'];
    },
  },
  methods: {
    required(v) {
      return !!v || 'Wybierz lokomotywę';
    },
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: this.type,
          locomotives: [this.locomotive],
        };

        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isLocomotiveControlReviewAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
</style>
